export default __webpack_public_path__ + "static/media/sharepoint-long.489676c4.svg";